<script>
    import { createEventDispatcher } from 'svelte'
    import { fly } from 'svelte/transition'
    import ActionButton from '../../../components/ActionButton/ActionButton.svelte'
    import SveltePerfectScrollbar from '../../../components/SveltePerfectScrollbar/SveltePerfectScrollbar.svelte'
    import moment from 'moment'
    

    export let items = null
    export let unix = 0
    export let height = 0
    export let busy = false

    let listInternal    = [],
        tempList        = [],
        monthstring     = '',
        latestClient    = null,
        isLastDayOfMnth = false,
        monthlyIdPart   = moment().format('YYYYMM') + '01',
        todayDOW        = moment().day(),
        tomorrowId      = moment().add(1, 'days').format ('YYYYMMDD'),
        nowMillis       = new Date().getTime()

    const dispatch = createEventDispatcher ();

    const guessPeriodicalType = cronstring => {
        const cronvalues = cronstring.trim().split (' ');
        // console.log ('cronvalues', cronvalues)

        if (cronvalues[2] === '*' && (cronvalues[4] === '*' || cronvalues[4].includes(','))) {
            return 'daily'
        } else if (cronvalues[2] === '1,15') {
            return 'biweekly'
        } else if (cronvalues[2] === '*' && cronvalues[4] !== '*') {
            return 'weekly'
        } else
            return 'once'
    }

    const updateList = (list) => {
        // console.log ('alertsRenderer', todayDOW)
        if (list) {
            isLastDayOfMnth = moment().month() === moment(unix).month() && moment().daysInMonth () === moment().date ()
            // console.log ('last day of current month?', isLastDayOfMnth, moment(unix).month())
            listInternal = []
            tempList = []
            list.sort ((a, b) => {
                return a.client.name > b.client.name ? 1 : -1
            }).forEach (it => {
                // console.log ('\nrule', it.client.name, it.cron, it.description, guessPeriodicalType (it.cron))
                if (it.instances.length) {
                    let periodType  = guessPeriodicalType (it.cron),
                        entry       = { ...it }
                        
                    entry.type = 'alert'
                    if (periodType === 'once') {
                        let chosenOne = it.instances[0];
                        if (chosenOne && chosenOne.resolved === false) {
                            if (isLastDayOfMnth === false || (isLastDayOfMnth && chosenOne.id === (monthlyIdPart + it.id))) {
                                entry.date = 'Questo mese'
                                entry.nextInstance = it.instances[0]
                                tempList.push (entry)
                            }
                        }
                    }

                    else if (periodType === 'biweekly') {
                        let withDistances = it.instances.map (inst => {
                            inst.distance = Math.ceil(moment.duration(nowMillis - moment(inst.millis).hour(8).valueOf()).asHours ()); // forcing hour to 7.00 to avoid timing mismatch
                            return inst
                        }).filter (it => it.resolved === false).sort ((a, b) => { return b.distance - a.distance })

                        console.log ('biweekly', withDistances.length)
                        if (withDistances.length > 0) {
                            let chosenOne = withDistances[0]
                            entry.date = moment (chosenOne.millis).format ('dddd DD/MM/YYYY HH:mm')
                            entry.nextInstance = chosenOne;
                            tempList.push (entry)
                        }
                    }

                    else if (periodType === 'weekly') {
                        let withDistances = it.instances.map (inst => {
                            // inst.distance = Math.ceil(moment.duration(nowMillis - inst.millis).asDays ())
                            // console.log ('instant', moment(inst.millis).hour(7).toDate())
                            inst.distance = Math.ceil(moment.duration(nowMillis - moment(inst.millis).hour(8).valueOf()).asHours ()); // forcing hour to 7.00 to avoid timing mismatch
                            // console.log ('==>', it.description, inst.distance)
                            return inst
                        }).filter (it => it.resolved === false && it.distance > (todayDOW === 6 ? -48 : -24) && it.distance <= 0).sort ((a, b) => { return b.distance - a.distance })

                        if (withDistances.length > 0) {
                            let chosenOne = withDistances[0]
                            entry.date = moment (chosenOne.millis).format ('dddd DD/MM/YYYY HH:mm')
                            entry.nextInstance = chosenOne;
                            tempList.push (entry)
                        }
                        // console.log ('weekly', it.client.name, withDistances)
                    }

                    else if (periodType === 'daily') {
                        let withDistances = it.instances.map (inst => {
                            inst.distance = Math.ceil(moment.duration(nowMillis - moment(inst.millis).hour(8).valueOf()).asHours ()); // forcing hour to 7.00 to avoid timing mismatch
                            return inst
                        }).filter (it => it.resolved === false && it.distance > (todayDOW === 6 ? -48 : -24) && it.distance <= 0).sort ((a, b) => { return b.distance - a.distance })
                        /*  note: todayDOW changes the time range if it's saturday 
                            (so you can see stuff which belongs to monday) ... */

                        if (withDistances.length > 0) {
                            let chosenOne = withDistances[0]
                            entry.date = moment (chosenOne.millis).format ('dddd DD/MM/YYYY HH:mm')
                            entry.nextInstance = chosenOne;
                            tempList.push (entry)
                        }
                    }
                }
            })

            tempList.forEach (it => {
                if (latestClient !== it.client.id) {
                    latestClient = it.client.id;
                    listInternal.push ({
                        id: Math.random (),
                        type: 'heading',
                        text: it.client.name
                    })
                }
                listInternal.push (it)
            })
            listInternal = listInternal;
            latestClient = null;
            tempList = []
            monthstring = moment (unix).format ('MMMM')
        }
    }

    $: {
        updateList (items)
    }
</script>

<style>
    .AlertsRenderer {
        background-color: #8696a0;
        cursor: default;
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
    }
    .AlertsRenderer .sidehead {
        font-weight: 600;
        font-size: 16px;
        padding: 10px 20px 5px;
        /* box-shadow: 0 0 2px #7a8c98; */
        color: #fff;
    }
    .AlertsRenderer .lbl {
        margin-top: 10px;
        font-weight: 600;
        padding: 0 20px;
        color: #3a4d58;
    }
    .AlertItem {
        padding: 5px 20px;
        font-size: 12px;
        cursor: default;
        color: #fff;
        position: relative;
    }
    .AlertItem:hover {
        /* background-color: var(--sidelink-hover); */
        /* background-color: var(--brand-1-color-sidebar-hover); */
        background-color: #62b1d0;
    }
    .AlertItem .hover {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        text-align: right;
        display: none;
    }
    .AlertItem:hover .hover {
        display: block;
    }
    .AlertItem .hover .ctrls {
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
        padding: 0 15px;
    }
    .AlertsRenderer .busylayer {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgb(112, 134, 148, .8);
    }
</style>

{#if listInternal.length}
    <div class="AlertsRenderer" transition:fly={{ y: 50, duration: 200 }}>
        <div class="sidehead">Alert {monthstring}</div>
        <SveltePerfectScrollbar height={height - 39}>
            {#each listInternal as alert (alert.id)}
                {#if alert.type === 'heading'}
                    <div class="lbl">{alert.text}</div>
                {:else}
                    <div class="AlertItem" on:click={e => dispatch ('select', { bean: alert })}>
                        <div>{alert.description}</div>
                        <div>{alert.date}</div>
                        <div class="hover">
                            <div class="ctrls">
                                <ActionButton icon="far fa-check" label="Ignora" on:click={e => dispatch ('resolve', { bean: alert })} />
                            </div>
                        </div>
                    </div>
                {/if}
            {/each}
        </SveltePerfectScrollbar>
        {#if busy}
            <div class="busylayer"></div>
        {/if}
    </div>
{/if}